import React from "react";
import { useTranslation } from 'react-i18next';

const GuideForFood = ({ openGuide, setOpenGuide }) => {
  const { t } = useTranslation();

  const handleClose = (e) => {
    e?.stopPropagation();
    setOpenGuide(false);
  };

  return (
    <>
      <div
        onClick={handleClose}
        className={
          openGuide
            ? "fixed left-0 top-0 z-10 h-full w-full bg-black opacity-70"
            : "hidden"
        }
      ></div>
      <div
        className={
          "maxW fixed left-0 right-0 z-[102] mx-auto h-[500px] overflow-scroll rounded-t-[32px] bg-white p-6 shadow-[0_0_12px_rgba(0,0,0,0.1)] duration-700 ease-in-out " +
          (openGuide ? "bottom-0" : "bottom-[-650px]")
        }
      >
        <div className="flex items-center justify-between overflow-hidden maxW">
          <h1 className="text-body3_700 text-gray_160">{t('meals:components.eye_measurement')}</h1>
          <img
            onClick={handleClose}
            src="/images/mobile/icon/close.svg"
            alt={t('meals:components.close_icon')}
            className="cursor-pointer"
          />
        </div>
        <p className="mb-4 text-caption2_400 text-main">
          {t('meals:components.eye_measurement_guide')}
        </p>
        <div className="pb-4">
          <img
            src="/images/mobile/image/guideForFood/guide-eng.svg"
            alt={t('meals:components.food_guide_image')}
            className="w-full"
          />
        </div>
      </div>
    </>
  );
};

export default GuideForFood;
